import type { Picker } from '#build/components'
import { country, payWay } from '@/pages/Recharge/ts/data'
import { getChargeList, createRechargeOrder } from '@/api/recharge'
import type { chargeInterface } from '@/types/apiType/rechargeType'
export const useRecharge = (fromPath: string) => {
  // 引入图片
  const imageUrl = (name: string): string => {
    return new URL(`../assets/image/recharge/${name}.png`, import.meta.url).href
  }

  const rechargeStore = useRechargeStore()
  const roomStore = useRoomStore()
  const callStore = useCallStore()
  const agoraStore = useAgoraStore()
  const trtcStore = useTrtcStore()

  const router = useRouter()
  const route = useRoute()
  const goBack = () => {
    router.back()
  }

  const userStore = useUserStore()
  const { userInfo, purseInfo } = storeToRefs(userStore)

  const publicStore = usePublicStore()

  // 国家选择弹窗 下拉菜单
  const dropText = ref('Indonesia')
  const dropValue = ref('ID')
  const countryIndex = ref(0)
  const countryPicker = ref<InstanceType<typeof Picker>>()
  const onConfirmCountry = (
    selectedOptions: { text: string; value: string }[]
  ) => {
    countryPicker.value && (countryPicker.value.showPicker = false)
    const value = selectedOptions[0].value
    const index = setCountryIndex(value)
    getList(11, value)

    countryIndex.value = index
    dropValue.value = value
    dropText.value = selectedOptions[0].text
    payIndex.value = 0
    myObj.showMoneyList = []
    myObj.payList = payWay[country[index].value]
  }
  // 选择国家弹窗显示
  function handleShowPicker() {
    countryPicker.value && (countryPicker.value.showPicker = true)
  }

  // 国家匹配
  const setCountryIndex = (value: string) => {
    let index = 0

    country.forEach((v, i) => {
      if (v.value === value) {
        index = i
      }
    })

    return index
  }

  // 支付方式和支付金额
  const payIndex = ref(0)
  const moneyIndex = ref(0)
  const isFirstCharge = ref(false) //是否是首充

  const myObj = reactive({
    payList: payWay['ID'], //充值方式列表
    moneyList: [] as chargeInterface[], //所有的充值金额列表
    showMoneyList: [] as chargeInterface[], //过滤后的充值金额列表
    chargeList: [] as chargeInterface[] //payermax充值列表
  })

  // 选择支付方式
  const selectPay = (index: number) => {
    payIndex.value = index
    // 沙特阿拉伯特殊处理，请求接口重新获取
    if (dropValue.value === 'SA') {
      // 支付方式是STCPAY就传14，其他11
      const paymentType = myObj.payList[payIndex.value].paymentType
      getList(paymentType === 'STCPAY' ? 14 : 11, dropValue.value)
    } else {
      filterMoneyList()
    }
  }

  // 选择金额
  const changeMoneyIndex = (index) => {
    moneyIndex.value = index
  }

  // 根据不同国家显示不同的支付列表
  const changeChargeList = () => {
    myObj.moneyList = myObj.chargeList
    myObj.showMoneyList = myObj.chargeList
  }

  // 过滤充值金额列表
  const filterMoneyList = () => {
    const lastMoney = myObj.showMoneyList[moneyIndex.value]?.money || 0 //记录上次选择的金额

    myObj.showMoneyList = []
    myObj.showMoneyList.push(...myObj.moneyList)
    // 找到对应金额档位赋值index索引，没有对应金额档位就重置索引为0
    const foundIndex = myObj.showMoneyList.findIndex(
      (v) => v.money === lastMoney
    )

    if (foundIndex === -1) {
      moneyIndex.value = 0
    } else {
      moneyIndex.value = foundIndex
    }
  }

  //获取支付列表
  function getList(channelType: number, countryCode: string) {
    getChargeList({ channelType, countryCode }).then((res) => {
      // console.log('支付列表', res)
      myObj.chargeList = res.data
      changeChargeList()
      filterMoneyList()
      isFirstCharge.value = myObj.moneyList[0]?.isFirstCharge || false
    })
  }

  // 设置默认国家显示
  const setDefaultCountry = (cty: string) => {
    const index = setCountryIndex(cty)
    // index 为0表示没有这个国家的支付方式 或者 为默认第一个国家
    if (index !== 0) {
      countryIndex.value = index
      dropValue.value = cty
      dropText.value = country[index].text
      countryPicker.value && (countryPicker.value.selectedValues[0] = cty)
      myObj.payList = payWay[country[index].value]
    }
  }

  // 创建订单，跳转到第三方收银台
  const rechargeClickLoading = ref(false)
  const rechargeClick = () => {
    rechargeClickLoading.value = true
    if (dropValue.value) {
      getPayermax()
    }
  }

  // 创建订单时要调的公共方法
  const commonFun = async (
    chargeInfo: {
      money: number
      chargeProdId: string
      prodName: string
      orderId: string
    },
    redirect: string
  ) => {
    // 创建订单埋点
    eventTracking.eventLog(eventTracking.eventId.create_a_recharge_order)
    // FB的添加支付信息标准事件埋点
    eventTracking.eventLog(eventTracking.eventIdFB.AddPaymentInfo, {
      content_name: chargeInfo.prodName,
      content_ids: chargeInfo.chargeProdId,
      currency: 'USD',
      value: chargeInfo.money
    })
    // 记录选择的金额和订单号，用于埋点
    localStorage.setItem('chargeInfo', JSON.stringify(chargeInfo))

    // 记录跳转的当前页面
    console.log(route.path)
    const isCallPgae = route.path === '/room/call' // 是否是视频通话界面
    const { path, query, params } = route
    // callUserInfo 是给复call时使用，先判断缓存用户信息再判断房间信息，判断是为了能拿到 uid nick avatar
    let callUserInfo = {}
    if (isCallPgae) {
      if (roomStore.anchorInfoStorage.uid) {
        callUserInfo = {
          uid: roomStore.anchorInfoStorage.uid,
          nick: roomStore.anchorInfoStorage.nick,
          avatar: roomStore.anchorInfoStorage.avatar
        }
      } else {
        callUserInfo = {
          uid: roomStore.roomInfo.uid,
          nick: roomStore.roomInfo.nick,
          avatar: roomStore.roomInfo.avatar
        }
      }
    }
    // trigger 是否触发充值回调页回到首页后跳转到当时充值的页面 在充值回调页设置为true
    localStorage.setItem(
      'rechargeFrom',
      JSON.stringify({
        path: path === '/recharge' ? fromPath : path, // 如果当前是充值页面，就取 fromPath ，如果不是就取 path 。
        query,
        params,
        callUserInfo,
        trigger: false
      })
    )

    // 如果在通话界面则需要先关闭通话再跳转页面
    if (isCallPgae) {
      roomStore.quit()
      callStore.quit()
      if (roomStore.roomType === constant.ROOM_TYPE.AUDIO_LIVE) {
        switch (roomStore.roomInfo.audioChannel) {
          case 1:
            // 声网
            await agoraStore.leave()
            break
          case 3:
            // 腾讯
            await trtcStore.exit()
            break
        }
      } else {
        switch (roomStore.roomInfo.audioChannel) {
          case 1:
            // 声网
            await agoraStore.leave()
            break
          case 3:
            // 腾讯
            await trtcStore.exit()
            break
        }
      }
    }

    //避免localStorage没存到值就跳转了
    setTimeout(() => {
      // 使用replace是为了保证不会回到 call页面
      if (isCallPgae) {
        window.location.replace(redirect)
      } else {
        window.location.assign(redirect)
      }
    }, 500)

    setTimeout(() => {
      publicStore.setShowRechargePopup(false)
      rechargeClickLoading.value = false // 重置状态
    }, 1000)
  }

  // payermax订单
  const getPayermax = () => {
    const chargeProdId = myObj.showMoneyList[moneyIndex.value].chargeProdId //商品id
    const money = myObj.showMoneyList[moneyIndex.value].money //商品价格
    const countryCode = country[countryIndex.value].value
    const paymentType = myObj.payList[payIndex.value].paymentType
    const prodName = myObj.showMoneyList[moneyIndex.value].prodName //商品名称
    createRechargeOrder({
      chargeProdId,
      countryCode,
      paymentType,
      app: 'web'
    }).then((res) => {
      if (res.code === 200) {
        const { orderId, redirect } = res.data
        // 插入pinia,做全局查询订单结果用于埋点
        rechargeStore.setRechargeList({
          money,
          chargeProdId,
          prodName,
          orderId
        })
        commonFun({ money, chargeProdId, prodName, orderId }, redirect)
      } else {
        rechargeClickLoading.value = false
        showToast(res.message)
      }
    })
  }

  onMounted(async () => {
    countryPicker.value && (countryPicker.value.columns = country)
    // 如果是充值页面再查询，因为充值页面和充值弹窗的 ts 是共用的
    if (route.path === '/recharge') {
      await userStore.requestUserInfo()
      setDefaultCountry(userInfo.value.country)
      getList(11, dropValue.value)
    }
  })

  // 弹窗代码
  const { rechargePopupConfig } = storeToRefs(publicStore)
  async function openPopup() {
    await nextTick()
    countryPicker.value && (countryPicker.value.columns = country)
    await userStore.requestUserInfo()
    setDefaultCountry(userInfo.value.country)
    // 国家支付列表 channelType传11
    getList(11, dropValue.value)
  }
  // 监听路由，切换页面关闭弹窗
  router.afterEach(() => {
    publicStore.setShowRechargePopup(false) // 弹窗使用，关闭弹窗
  })

  return {
    imageUrl,
    goBack,
    userInfo,
    payIndex,
    selectPay,
    dropValue,
    dropText,
    myObj,
    moneyIndex,
    countryIndex,
    country,
    changeMoneyIndex,
    isFirstCharge,
    rechargeClick,
    countryPicker,
    onConfirmCountry,
    handleShowPicker,
    rechargeClickLoading,
    rechargePopupConfig,
    openPopup,
    purseInfo
  }
}
